<template>
  <div>
    <div class="col-md-12 banner">
      <vueper-slides
        :fade="false"
        :touchable="true"
        :fixed-height="false"
        :arrows="false"
        :slide-ratio="0.5"
        :transition-speed="1000"
        :autoplay="true"
      >
        <vueper-slide :image="require('@/assets/images/banners/1.jpeg')" />
        <vueper-slide :image="require('@/assets/images/banners/2.jpeg')" />
        <vueper-slide :image="require('@/assets/images/banners/3.jpeg')" />
        <vueper-slide :image="require('@/assets/images/banners/4.jpeg')" />
        <vueper-slide :image="require('@/assets/images/banners/5.jpeg')" />
        <vueper-slide :image="require('@/assets/images/banners/6.jpeg')" />
        <vueper-slide :image="require('@/assets/images/banners/7.jpeg')" />
        <vueper-slide :image="require('@/assets/images/banners/8.jpeg')" />
        <vueper-slide :image="require('@/assets/images/banners/9.jpeg')" />
        <vueper-slide :image="require('@/assets/images/banners/10.jpeg')" />
      </vueper-slides>

      <div class="intro-sub font-style-spp">
        <h3 class="intro-subtitle">BE THE DESIGNER</h3>
        <h4 class="intro-title">BUILD YOUR OWN PRODUCT</h4>
        <a href="/product" class="star-button">
          <span class="icon">&gt;</span>
          <span class="name">START NOW</span>
        </a>
      </div>
      <div class="intro-content-controller-downIcon">
        <a href="#product-configuration" class="" style="z-index: 2000">
          <img
            class="intro-content-controller-downIcon"
            src="@/assets/images/Arow_in_Circle.png"
            alt="Footer Logo"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  // ...
  name: "MyComponent",
  components: { VueperSlides, VueperSlide },
};
</script>

<style lang="scss" scoped>
.star-button {
  font-weight: 400 !important;
  cursor: pointer;
  border-radius: 10px !important;
  background-color: #ccccccc2 !important;
  padding: 10px !important;
  min-width: unset !important;
  color: #000;
  display: inline-block;
  line-height: 15px;
  //font-family: "Poppins";
}
.star-button span.icon {
  float: left;
  font-size: 30px;
  //font-family: "Poppins";
}
.star-button span.name {
  font-size: 17px;
  //font-family: "Poppins";
}
.intro-title {
  color: #fff;
  font-weight: 500 !important;
  font-size: 27px !important;
  line-height: 1 !important;
  letter-spacing: -0.03em;
  margin-bottom: 1.2rem !important;
  text-indent: -0.2rem;
  text-shadow: 2px 2px 3px #000 !important;
  //font-family: "Poppins";
  font: normal 300 1.4rem/1.86 "Poppins", sans-serif;
}

.intro-subtitle {
  color: #fff;
  font-weight: 200 !important;
  font-size: 33px !important;
  letter-spacing: -0.01em !important;
  margin-bottom: 0.5rem !important;
  text-shadow: 2px 2px 3px #000 !important;
  font-family: source sans pro, sans-serif;
}

.banner {
  margin-top: 135px;
  position: relative;
  @media (max-width: 600px) {
    margin-top: 90px;
  }

  .intro-sub {
    position: absolute;
    z-index: 2;
    top: 2rem;
    width: 100%;
    text-align: center;
  }

  .intro-content-controller-downIcon {
    width: 3rem;
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    z-index: 2;
  }
}
</style>

<style lang="scss">
.banner {
  .vueperslide {
    background-size: cover;
    background-repeat: no-repeat;
  }

  .vueperslides:not(.no-shadow):not(.vueperslides--3d)
    .vueperslides__parallax-wrapper:after,
  .vueperslides:not(.no-shadow):not(.vueperslides--3d)
    .vueperslides__parallax-wrapper:before {
    z-index: 0;
    box-shadow: none;
  }
}
</style>